import { useGlobalState } from '@highlight/ipc/react'
import { parse, type SemVer } from 'semver'
import { installedVersionWithSuffix, StaticBuildChannel } from '@highlight/common'
import { getInstalledChannel, getStartupChannel } from '@shared/utils/builds/channels.shared'

interface AppVersionInfo {
  version: string
  channel: string
  semver: SemVer | null
  isAlpha: boolean
  isBeta: boolean
  isLatest: boolean
}

export const useAppVersion = (): AppVersionInfo => {
  const [rawVersion] = useGlobalState('versions.app', 'N/A')
  const version = installedVersionWithSuffix(rawVersion, getInstalledChannel())
  const channel = getStartupChannel()

  return {
    version,
    channel,
    semver: parse(version),
    // @deprecated
    isAlpha: channel === StaticBuildChannel.alpha,
    isBeta: channel === StaticBuildChannel.beta,
    isLatest: channel === StaticBuildChannel.latest,
  }
}
